import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/auth';
import UserNewContainer from '../../components/users/UserNewContainer';

const UserNewPage = () => {
  const navigate = useNavigate();
  const { me } = useAuth();

  useEffect(() => {
    if (!me) return;
    if (!me?.isSuperuser && !me?.role?.changeUsersProfile) navigate('/');
  }, [me, me?.isSuperuser, me?.role?.changeUsersProfile, navigate])

  return (
    <Box>
      <UserNewContainer />
    </Box>
  )
}

export default UserNewPage;
